const warehouse = {
  inventoryOrderList: '採購單入庫',
  orderNumber: '訂單編號',
  documentNumber: '單證編號',
  changeType: '變更類型',
  lot: '批次',
  quantity: '數量',
  totalIn: '總入庫',
  totalOut: '總出庫',
  inventory: '盤點',
  balance: '結餘',
  plSelectProduct: "請選擇商品",
  plProductNum: "請輸入商品數量",
  productNumMin: "商品數量最少為{{ num }}",
  addProduct: "添加商品資訊",
  addProductForm: "填寫{{ name }}單",

  inbound: '入庫',
  outbound: '出庫',

  deliveryOrderNumber: '送貨（入庫）單號',
  materialRequisitionNumber: '領料（出庫）單號',

  inboundOprt: '我要入庫',
  outboundOprt: '我要出庫',
  outboundError: '出庫失敗',
  outboundSuccess: '出庫成功',
  insufficientInventory: '庫存不足',
  forceOutbound: '是否強制出庫？',
  forceOutboundFailed: '強制出庫失敗',
  inboundError: '入庫失敗',
  outboundNotEnough: '庫存數量不足',
  returnStock: '退庫',
  returnStockSuccess: '退庫成功',
  returnStockFail: '退庫失敗',
  returnQuantity: '退庫數量',
  selectLocationToReturn: '選擇要退庫的庫位',
  selectLocationToInbound: '選擇入庫庫位',
  available: '可用',
  returnExceedsAvailable: '退庫數量超過可用數量',
  returnExceedsOriginal: '退庫數量超過原單數量 {{original}}',
  validationError: '驗證失敗',
  sourcesPick: '領料',
  pickingOutbound: '領料出庫',
  sourcesInReturn: '入庫單退回',
  sourcesOutReturn: '出庫單退回',

  numDetail: '錄入數量詳情',
  productNum: '商品數量',

  arrivalAt: '到貨時間',
  remark: '備註',
  enterRemark: '請輸入備註',
  requiredArrivalAt: '要求到貨時間',
  actualArrivalAt: '實際到貨時間',
  plArrivalAt: '請輸入到貨時間',
  startTime: '開始時間',
  endTime: '結束時間',
  deliveryStartTime: '送貨開始時間',
  deliveryEndTime: '送貨結束時間',
  plProduct: '請選擇商品',
  inQuantity: '入庫數量',
  plInQuantity: '請輸入入庫數量',
  outQuantity: '出庫數量',
  plOutQuantity: '請輸入出庫數量',
  codeRepeat: '條碼重複，請刪除後再次操作',
  orderType: '入庫單類型',
  inOrder: '入庫單',
  preInOrder: '送貨單入庫（預入庫）',
  purchaseOrder: '採購單',
  selectOrderType: '請選擇入庫單類型',
  selectOrderNumber: '請輸入入庫單號',
  numberNotExist: '單號不存在',
  orderConfirmed: '該訂單已確認',
  purchaseNotPass: '採購未通過',
  saveOrder: '保存入庫單',
  orderSuccess: '入庫成功',
  code: '條碼',
  existCode: '已存在',
  deleteBarcode: '確定刪除條碼？',
  deleteBarcodeSuccess: '刪除成功',
  clearCode: '確定清空條碼？',
  clear: '清空條碼',
  existBarcode: '已錄入條碼:',
  outboundType: '出庫類型',
  inboundType: '入庫類型',
  preOutOrder: '領料單出庫（預出庫）',
  outSuccess: '出庫成功',
  tempIn: '臨時入庫',
  tempOut: '臨時出庫',
  preIn: '預入庫數量',
  preOut: '預出庫數量',
  product: '商品',
  salesOrder: '銷售單',
  outOrder: '出庫單',
  specialOutbound: '專用料出庫（需求清單）',
  exportExcel: '導出Excel',
  packingExportConfirm: '確定要導出分揀單嗎？',
  specialMaterialList: '專用料列表',
  specialOutSuccess: '專用料出庫成功',
  specialOutFail: '專用料出庫失敗',
  normalMaterialList: '公共庫列表',
  count: '庫存數量',
  thirdPartyBatch: '供應商批次號',

  inOK: "入庫成功",
  outOK: "出庫成功",
  inFail: "入庫失敗",
  outFail: "出庫失敗",

  // 庫存管理
  materialList: '物料列表',
  locationList: '庫位列表',
  realMaterialList: "在庫庫存",
  locationCode: '庫位編碼',
  searchMaterialPlaceholder: '搜索物料編碼/名稱',
  searchLocationPlaceholder: '搜索庫位編碼',
  searchBatchPlaceholder: '搜索批次號/供應商批次號',
  searchMultiCodePlaceholder: '搜索存貨編碼（支持多個用空格分隔）',
  batchList: '批次列表',
  materialDetail: '物料明細',
  lotCount: '批次數量',
  locationDetail: '庫位明細',
  barcodeList: '條碼列表',
  state: '狀態',
  lotItemLocationId: '批次庫位ID',
  viewBarcode: '查看條碼',
  batchNo: '批次號',
  deliveryBatchNo: '送貨批次號',
  supplierBatchNo: '供應商批次號',
  labels: '標籤',
  addLocation: '新增庫位',
  editLocation: '編輯庫位',
  locationIndex: '庫位索引',
  label1: '標籤1',
  label2: '標籤2',
  label3: '標籤3',
  label4: '標籤4',
  label5: '標籤5',
  locationDescPlaceholder: '請輸入庫位描述',
  addLocationSuccess: '新增庫位成功',
  addLocationFailed: '新增庫位失敗',
  updateLocationSuccess: '更新庫位成功',
  updateLocationFailed: '更新庫位失敗',
  l1Required: 'L1不能為空',
  l2Required: 'L2不能為空',
  l3Required: 'L3不能為空',
  l4Required: 'L4不能為空',
  l5Required: 'L5不能為空',
  l1RequiredFirst: '請先填寫L1',
  l2RequiredFirst: '請先填寫L2',
  l3RequiredFirst: '請先填寫L3',
  l4RequiredFirst: '請先填寫L4',

  // 新增的國際化配置
  location: '庫位',
  locationLabel: '庫位標籤',
  selectLocation: '選擇庫位',
  searchLocation: '搜索庫位',
  locationExist: '該庫位已存在',
  editBarcodes: '編輯條碼',
  fetchError: '獲取數據失敗',
  barcodesExceedCount: '條碼數量不能超過庫位數量',
  checkBarcodes: '請檢查條碼',
  barcodesExceedNewCount: '條碼數量超過新設定的庫位數量，請先調整條碼',
  barcodesAutoTrimmed: '條碼已自動截取',
  barcodesAutoTrimmedDesc: '條碼數量超過庫位數量，已自動保留前 {{count}} 個條碼',
  totalExceedItemCount: '總數量超過限制',
  totalExceedItemCountDesc: '庫位總數量 {{current}} 超過訂單項數量 {{total}}',
  cannotAddLocation: '無法添加庫位',
  totalReachedItemCount: '庫位總數量已達到訂單項數量 {{total}}',
  inboundSuccess: '入庫成功',
  inboundFailed: '入庫失敗',
  quantityMismatch: '數量不匹配',
  quantityMismatchDesc: '以下商品的庫位數量總和與訂單數量不一致：',
  currentTotal: '當前總數',
  requiredTotal: '需求數量',
  changeLocation: '更換庫位',
  partialInboundSuccess: '部分入庫成功',
  removeOldLocationsFailed: '清除舊庫位數據失敗',
  barcodeCount: '條碼個數',
  someItemsInboundFailed: '有商品入庫失敗',
  inboundResultDetail: '{{success}} 個商品入庫成功，{{failed}} 個商品入庫失敗',
  failedItems: '失敗商品',
  noBarcodes: '暫無條碼數據',

  outNo: "出庫單號",
  innerNo: "內部單號",
  outData: "出庫日期",
  outWare: "出貨倉庫",
  llorg: "領料部門",
  llper: "領料人",
  documentType: "單據類型：",
  outper: "出庫員",
  inper: "入庫員",
  wareper: "倉管",
  outCheckDate: "審核日期",

  returnRn: "退貨原因: ",
  surplus: "正常結餘退庫",
  defective: "不良品退庫",
  refurbished: "不良品加工",
  forceReturn: "是否確認退庫？",
  barcodeErr: "條碼有誤",
  forceInbound: "是否強制入庫？",
  forceInboundFailed: "強制入庫失敗",
  forcedErr: "強制入庫失敗",
  moveLoc: "移庫",
  targetLocation: "目標庫位",
  moveCount: "移庫數量",
  maxMoveCount: "最大移庫數量",
  moveFail: "移庫失敗",
  moveCurTip: "目標庫位不能和當前庫位一致",
  pleaseSelectLocation: "請選擇庫位",
  pleaseInputCount: "請輸入數量",
  countExceedMax: "數量超過最大值",
  reoutrecvdpicking: "誤出庫領料",

  locationIndexExsist: '庫位索引：{{index}}已存在',

  // 庫位出庫
  locationOutbound: "庫位出庫",
  outNum: "出庫數量",
  outBarcodes: "出庫條碼",
  selectBarcode: "選擇條碼",
  confirmOutboundTip: "確認出庫？",
  confirmOutboundDesc: "確定要對所選批次進行出庫操作嗎？",
  inventoryMismatch: "庫存數據不匹配，請重新核對數據",

  // 條碼和掃描單相關
  unsavedData: "有數據未進行保存",
  cancelWithoutSave: "取消後, 數據不可恢復",
  confirmDeleteBarcode: "確定要刪除條碼嗎?",
  deleteCannotRecover: "刪除後, 數據不可恢復",
  confirmDeleteScanSheet: "確定要刪除掃描單嗎?",
  scanSheet: "掃描單",
  completeScanSheetInbound: "完成掃描單, 確定入庫",
  barcodesNotInOriginal: "以下條碼不存在於原始條碼列表中：{{barcodes}}",
  barcodeDuplicateInLocations: "條碼{{barcode}}在{{locationCodes}}中重複",

  // 條碼生成相關
  validationFailed: "校驗失敗",
  dataInvalid: "數據不合法, 每個掃描單數據不得超過{{max}}",
  generateFailed: "生成失敗",
  maxBarcodeCount: "已達到最大條碼數量限制 {{count}} 個",
  batchGenerateBarcodes: "批量生成條形碼",
  optional: "可不填",

  // 退庫相關
  returnStockModal: "退庫",
  orderList: "訂單列表",
  leastOneMove: "至少一個批次移庫數量大於0",
  confirmPreOut: "確定執行預出庫麼",
  sign: "簽收",
  signed: "已簽收",
  signSucc: "簽收成功",
  signFail: "簽收失敗",
  plSignDate: "選擇簽收日期",
  productRef: "商品推荐",
  selectProduct: "選擇商品",
  productExists: "商品已存在",
  addLocationRef: "添加庫位商品關聯",
  confirmBatchDelete: "確定要批量刪除所選的庫位商品關聯嗎？",
  confirmDeleteItem: "確定要刪除這條庫位商品關聯嗎？",
  allocatePreOut: "分配預出庫",
  allocatePreOutSuccess: "分配預出庫成功",
  allocatePreOutFail: "分配預出庫失敗",

  // 手工入庫相關
  manualInbound: "手工入庫",
  complete: "完成",
  delete: "刪除",
  productCode: "商品編碼",
  productName: "商品名稱",
  productModel: "商品型號",
  uom: "單位",
  noData: "暫無資料",
  previous: "上一步",
  next: "下一步",
  confirm: "確定",
  notRecommendedLocation: "您選擇的庫位不是推薦庫位",
  isNotRef: "該庫位不是推薦庫位",
  recommendedLocations: "推薦庫位",
  allLocations: "全部庫位",
  locationsRequired: "請為每個商品添加庫位",
  locationCountRequired: "庫位數量不能為空或0",
  inboundComplete: "入庫完成",
  inboundSuccessDesc: "入庫操作已成功完成",
  otherOut: "其他出庫",
  outNumNotZ: "出庫數量不可為0",
  outNumExceedStock: "出庫數量超出可用庫存數量",
  productInput: "錄入物料",
  locNumnotOrder: "庫位總數量不等於入庫數量，請修改",
  outOvernum: "出庫數量超出{{num}}個",
  outLossnum: "出庫數量缺失{{num}}個",
  outboundLocationError: "以下物料沒有出庫庫位",
  outboundCountMismatch: "以下物料出庫數量不等於要出庫的數量，請修改數據",
  noStock: "沒有庫存",
  delOutTip: "預出庫單{{number}}已經生成，是否刪除？",
  inputer: "製單人",
  confirmer: "確認人",
  locFailed: "庫位信息與訂單信息不匹配，請檢查",
  reMatchTip: "出庫確認失敗，需要重新匹配庫存",
  reMatchSucc: "庫位已重新分配，數據已更新",
  reMatchFail: "重新匹配庫存失敗",
  delInTip: "預入庫單{{number}}已經生成，是否刪除？",
  delInSucc: "預入庫單{{number}}生成成功",
  inboundUpdateSucc: "預入庫單數據已更新",
  delOrderClose: "刪除單據",
  notDelClose: "保留單據",
  needPrefit: '預檢出現問題，以下出庫批次信息需要修正',
  needSucc: '預檢成功，出庫數據無需修正',
  needFail: '預檢失敗，獲取庫存信息失敗',
  outPrefit: '出庫預檢',
  fixOut: '修改出庫',
  fixSucc: '出庫信息修改成功！',
  fixFail: '出庫信息修改失敗！',
  outQtyErr: '出庫數量分配錯誤！',
  fetchStockError: '庫存獲取失敗！',
  oldItemInfo: '原出庫信息',
  returnInfo: '退庫單信息',
  delReturnClose: "退庫單{{number}}已經生成，是否刪除？",
  confirmReturnTip: "確認退庫？",
  returnNumber: "退庫單號",
  noUseStock: "沒有可用的庫存",
  noLotStock: "該退庫批次沒有庫存：{{lot}}",
  noCodeStock: "該物料沒有庫存：{{code}}",
  returnLot: "退庫批次",
  needFix: "確認出庫失敗，請進行出庫預檢並修正出庫信息或重新分配庫存",
  rePreout: "重新分配庫存",
  orderCount: "本次出庫數量",
  useAmtReq: "所需總數",
  pickingOutbound_m: "材料出庫",
  productOldCount: "確認前物料數量",
  productNewCount: "確認後物料數量",
  lotItemOldCount: "確認前批次數量",
  lotItemNewCount: "確認後批次數量",
  noconf: "未確認",
  confed: "已確認",
  plconfed: "是否已確認",
  refNo: "關聯單號",
  proIn: "生產入庫",
  locProNot: "庫存不足：庫位：{{locIdx}}，物料{{proCode}}",
  signTime: "簽收時間",
  prodTempIn: "生產入庫（臨時）",
  iqcState: "質檢狀態",
  notIqc: "未質檢",
  iqcEd: "已質檢",
  iqcCheck: "IQC質檢",
  iqcList: "IQC質檢單列表",
  iqcNumber: "質檢單號",
  iqcInventory: "出入庫單號",
  iqcType: "質檢類型",
  iqcUser: "質檢員",
  iqcRes: "質檢結果",
  iqcTime: "質檢時間",
  toQc: "待檢",
  qcIng: "檢驗中",
  passQc: "通過",
  failQc: "不通過",
  front: "外觀不良",
  size: "尺寸不良",
  power: "性能不良",
  package: "包裝不良",
  tag: "標識不良",
  other: "其他",
  dispReturn: "退貨",
  dispAcpt: "讓步接收",
  dispRedo: "返工",
  qcInbound: "入庫質檢",
  qcOutbound: "出庫質檢",
  qcWarehouse: "在庫質檢",
  qcProgress: "過程質檢",
  qcReturn: "退貨質檢",
  typePl: "請選擇質檢類型",
  statePl: "請選擇質檢狀態",
  fetchErr: "質檢單獲取失敗！",
  createdAt: "製單時間",
  creator: "製單人",
  desc: "質檢備註",
  qcItems: "質檢項",
  checkCount: "質檢數量",
  passCount: "合格數量",
  failCount: "不合格數量",
  qcResult: "質檢結果",
  defectType: "不良品類型",
  disposition: "處置結果",
  doc: "質檢附件",
  remarks: "備註",
  qcItemList: "質檢物料列表",
  addQc: "新增QC質檢單",
  qcOrder: "質檢單",
  selectInventory: "選擇出入庫單",
  writeQc: "填寫質檢信息",
  itemCount: "訂單數量",
  descPl: "請輸入質檢備註",
  checkCountPl: "請輸入質檢數量",
  passCounPl: "請輸入合格數量",
  failCountPl: "請輸入不合格數量",
  qcResultPl: "請選擇質檢結果",
  defectTypePl: "請選擇不良品類型",
  dispositionPl: "請選擇處置結果",
  qcTyePl: "請選擇質檢類型",
  add: "生成質檢單",
  addErr: "生成質檢單失敗，沒有數據",
  addErr1: "生成質檢單失敗",
  done: "完成",
  doneTip: "質檢單{{number}}已生成成功！",
  itemDesc: "請填寫質檢項備註",
  noUpdate: "沒有數據更新，無需保存",
  updateSucc: "保存成功",
  havePass: "已通過",
  notPass: "通過失敗！",
  hasUpdata: "有更改未保存，是否保存後再通過？",
  canNotPass: "完成失敗",
  canNotPassTip: "請確保所有質檢項都有質檢結果",
  qcDone: "{{number}}質檢完成",
  reQc: "重新質檢",
  doneQC: "完成質檢",
  optSucc: "操作成功",
  optFail: "操作失敗",
  canAddQc: "可以繼續添加質檢單",
  orderQcDone: "出入庫單：{{number}} 質檢完成【{{res}}】",
  normalPrint: "橫版分頁",
  verticalPrint: "豎版連續",
  manual: "手工",
  production: "生產",
  purchase: "採購",
  sale: "銷售",
  dispose: "調撥",
  sourceType: "類型",
  packing: "倉庫分揀",
  packingNo: "分揀單號",
  perBoxQuantity: "數量/箱",
  perBoxNetWeight: "淨重/箱",
  perBoxGrossWeight: "毛重/箱",
  totalQuantity: "數量",
  totalNetWeight: "淨重",
  totalGrossWeight: "毛重",
  measurements: "尺寸",
  packingVolume: "體積",
  draft: "草稿",
  confirmed: "已確認",
  shuted: "已封箱",
  wasted: "已作廢",
  packStatus: "分揀狀態",
  totalBoxes: "箱數",
  grossWeight: "毛重",
  netWeight: "淨重",
  totalVolume: "體積",
  delTip: "你確定作廢分揀單：{{no}} 嗎？",
  addPack: "添加分揀單",
  inventoryPl: "請選擇出庫單",
  inventoryInPl: "請選擇入庫單",
  orderPl: "請選擇出入庫單",
  packDtl: "分揀單詳情",
  closeBox: "封箱",
  openBox: "解封",
  killed: "作廢",
  confirmSucc: "確認成功",
  confirmFail: "確認失敗",
  sealSucc: "封箱成功",
  sealFail: "封箱失敗",
  unSealSucc: "解封成功",
  unSealFail: "解封失敗",
  wasteFail: "作廢失敗",
  items: "商品項",
  boxes: "分揀單明細",
  boxNo: "箱號",
  boxBarcode: "箱碼",
  lengthMm: "長(cm)",
  widthMm: "寬(cm)",
  heightMm: "高(cm)",
  volumeCbm: "體積(cm³)",
  grossWeightG: "毛重(kg)",
  netWeightG: "淨重(kg)",
  packageType: "包裝類型",
  marksNumbers: "嘜頭",
  delBoxTip: "你確定要刪：{{no}}嗎？",
  addBox: "添加箱子",
  editBox: "編輯箱子 {{no}}",
  boxAddItem: "分揀",
  boxedCount: "已分揀數量",
  plItem: "請選擇分揀項",
  boxEditItem: "修改分揀信息",
  boxItemQty: "分揀數量",
  declaredUnitPrice: "單價",
  declaredCurrency: "幣種",
  hsCode: "HS編碼",
  originPlace: "源產地",
  productNameCn: "中文名",
  productNameEn: "英文名",
  brand: "品牌",
  brandType: "品牌類型",
  packingModel: "型號",
  packingOrigin: "產地",
  exportBrandName: "出口品牌名",
  declaredAmount: "總價",
  shutErr: "封箱失敗",
  weightNeed: "請填寫毛重和淨重",
  shipmentOut: "發貨出庫",
  noShipment: "發貨單不存在",
  noOrder: "單據不存在",
  outItems: "出庫明細",
  plPreLOcTypes: "請選擇出庫匹配庫位類型",
  shipOutData: "發貨出庫數據",
  outDone: "出庫完成",
  noBox: "沒有箱子或箱子為空！",
  needPre: "發貨出庫單請先分配庫存",
  selectSaleOrder: "選擇銷售單",
  noOutOrder: "沒有出庫單",
  noOutOrderTip: "沒有已確認的出庫單",
  outOrderFail: "出庫單載入失敗",
  selectOutOrder: "選擇出庫單",
  remainPack: "剩餘分揀數量",
  selectLot: "選擇批次",
  genShip: "生成發貨單",
  searchCode: "搜索料號",
  plSelBox: "請勾選需要發貨的箱子",
  plInQuantityLot: "請輸入入庫數量和lot",
  packOrder: "分揀單",
  toClose: "待封箱",
  gWeightNeed: "請填寫毛重",
  addOutOrder: "添加出庫單",
  sealAllTip: "分揀單全部箱子都已封箱，單據確認後整單將自動封箱。",
  emptyBox: "空的箱子：{{number}}",
  selectCustomer: "選擇客戶",
  selectCustomerPl: "請選擇客戶",
  multiBox: "多箱錄入",
  addingTip: "請輸入箱子個數（包含當前箱子）",
  addPackQty: "箱數",
  newBoxNumber: "新箱號",
  selBoxErr: "勾選項不合法",
  selBoxErrTip1: "只能勾選已封箱並且未生成過發貨單的箱子",
  selBoxErrTip2: "不能勾選空箱子或已經封箱的箱子",
  selBoxErrTip3: "以下箱子已被過濾",
  batchSeal: "批量封箱",
  plBatchSeal: "請勾選要封箱的箱子",
  batchGross: "批量應用毛重（勾選後，將同步更改當前所有箱子的毛重）",
  batchSealSucc: "批量封箱成功",
  batchSealErr: "批量封箱失敗",
  editBoxErr: "修改箱子重量失敗，箱號：{{number}}",
  sealBoxErr: "封箱失敗，箱號：{{number}}",
  filterdSeal: "已封箱的箱子和空箱子已被忽略",
  noSealBox: "沒有可以封箱的箱子",
  sealRange: "封箱範圍",
  boxNoPl: "請輸入箱號",
  reset: "重置",
  startNo: "開始箱號",
  endNo: "結束箱號",
  searchRange: "搜索範圍",
  productType: "產品類型",
};

export default warehouse;
